/**
 * Build a complete locale: every key from English base gets a native string.
 * Missing keys fall back to English (never Hindi) for te/kn pure mode.
 */
export function buildPureLocale(enBase, nativeMap) {
  const out = {};
  for (const key of Object.keys(enBase)) {
    out[key] = nativeMap[key] ?? enBase[key];
  }
  return out;
}
